import * as React from 'react';
import * as style from './style.css';
import { IconChevronLeft16, UIHeading2, UIText2 } from '@cian/ui-kit';
import { Link } from '../Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FlatPlanHeader = function FlatPlanHeader(_ref) {
  var onClose = _ref.onClose,
    onOfferClick = _ref.onOfferClick,
    title = _ref.title,
    offerUrl = _ref.offerUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: style['header'],
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['header-back-button'],
      onClick: onClose,
      children: [/*#__PURE__*/_jsx(IconChevronLeft16, {
        color: "primary_100"
      }), /*#__PURE__*/_jsx(UIText2, {
        color: "primary_100",
        children: "\u041D\u0430\u0437\u0430\u0434 \u043A \u043F\u043B\u0430\u043D\u0443 \u044D\u0442\u0430\u0436\u0430"
      })]
    }), /*#__PURE__*/_jsx(UIHeading2, {
      children: title
    }), /*#__PURE__*/_jsx(Link, {
      href: offerUrl,
      target: "_blank",
      onClick: onOfferClick,
      children: "\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0435"
    })]
  });
};